import { Component, OnInit } from '@angular/core';
import {ReactiveFormsModule, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PARTNERS } from '../core/constants';
import { UserService } from '../core/_services/user.service';
import { UtilitiesService } from '../core/_services/utilities.service';
import { SnackBarNotificationComponent } from '../shared/_components/snack-bar-notification/snack-bar-notification.component';
import {EventTrackingService} from "../core/_services/event-tracking.service";
import {UrlParamsService} from "../core/_services/url-params.service";
import {RouterLinkWithHref} from "@angular/router";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NgIf} from "@angular/common";

@Component({
    standalone: true,
    selector: 'app-firestone',
    templateUrl: './firestone.component.html',
    imports: [
        RouterLinkWithHref,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        NgIf,

    ],
    styleUrls: ['./firestone.component.scss']
})

export class FirestoneComponent implements OnInit {
    currentYear: any;
    newsLetterForm: FormGroup;
    externalReferralId: number;
    showStickyFooter = true;

    constructor(
        protected userService: UserService,
        private formBuilder: FormBuilder,
        private snackBar: MatSnackBar,
        private eventTrackingService: EventTrackingService,
        private utilitiesService: UtilitiesService,
        private urlParamsService: UrlParamsService) {
    }

    ngOnInit() {
        this.newsLetterForm = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email]]
        });
        this.getPartnerId();
        this.currentYear = new Date().getFullYear();
    } // ngOnInit()

    get email() {
        return this.newsLetterForm.get('email');
    }

    private getPartnerId(): void {
        const params: any = {
            company: PARTNERS.BRIDGESTONE
        };
        this.userService.getPartnerId(params, this.constructor.name).subscribe(response => {
            if (UtilitiesService.isNotEmpty(response.partnerId)) {
                const user = this.userService.getCurrentUserData();
                this.userService.updateUserData({partnerId: response.partnerId, ...user});
                this.createReferral(response.partnerId);
            }
        }, error => {
            UtilitiesService.consoleLog(error);
        });
    } // getPartnerId()

    private createReferral(partnerId: number): void {
        let extraParams: any;
        try {
            extraParams = JSON.parse(this.utilitiesService.getLocal("extraParams"));
        } catch (e) {
            UtilitiesService.consoleLog(e);
        }
        const source = this.utilitiesService.getLocal("utm_source");
        const referralParams: any = {
            partnerId: partnerId,
            source: UtilitiesService.isNotEmpty(source) ? source : "web",
            params: extraParams
        };
        this.userService.addReferral(referralParams, this.constructor.name).subscribe(response => {
            if (UtilitiesService.isNotEmpty(response.externalReferralId)) {
                this.externalReferralId = response.externalReferralId;
                this.utilitiesService.setLocal("externalReferralId", this.externalReferralId);
                const params: any = {
                    promoCode: 'FIRESTONE2022',
                    token: this.eventTrackingService.persistentKey
                };
                this.userService.savePromoCode(params, 'firestone-landing').subscribe();
                this.createProspect();
            }
        }, error => {
            UtilitiesService.consoleLog(error);
        });
    } // createReferral()

    createProspect(): void {
        // get whatever current prospect data we have (likely zip)
        let prospect: any = this.userService.getCurrentUserData();
        prospect = UtilitiesService.isNotEmpty(prospect) ? prospect : {};

        // if they provided an email, add it
        if (UtilitiesService.isNotEmpty(this.email.value)) {
            prospect.email = this.email.value;
        }

        // if we don't have any user details yet, don't do anything
        if (UtilitiesService.isEmpty(prospect)) {
            return;
        }

        prospect.externalReferralId = this.externalReferralId;
        prospect = this.urlParamsService.addTrackingParams(prospect);
        this.userService.newProspect(prospect, this.constructor.name).subscribe(response => {
            prospect.prospectId = response.prospectId;
            this.userService.updateUserData(prospect);
            if (UtilitiesService.isNotEmpty(this.email.value)) {
                this.snackBar.openFromComponent(SnackBarNotificationComponent, {
                    duration: UtilitiesService.seconds(3),
                    data: {
                        message: "Email successfully updated."
                    }
                });
            }
        }, error => {
            this.snackBar.openFromComponent(SnackBarNotificationComponent, {
                duration: UtilitiesService.seconds(3),
                data: {
                    message: error.message
                }
            });
            UtilitiesService.consoleLog(error);
        });
    } // createProspect()

}
